module.exports = __webpack_public_path__ + "img/woa_worldventure.608b719.png";